module.exports = {
  url: process.env.NODE_ENV === 'development' ? 'https://api-drachei.herokuapp.com' : 'https://api.drachei.com.br',
  urlPayment: process.env.NODE_ENV === 'development' ? 'https://powerdevs.minivps.info:3000' : 'https://payment.drachei.com.br',
  urlGrupoSin: process.env.NODE_ENV === 'development' ? 'https://portal-grupo-sin-stage.herokuapp.com' : 'https://api.sinsaudecard.com.br'
}



// WEBPACK FOOTER //
// ./src/endpoint.js